import {
  useGetAllEnabledExamCoursesQuery,
  useGetExamEventsByDateRangeQuery,
  useGetExamEventCoursesByExamEventIdsQuery,
} from '@exam-center/graphql';

interface UseGetMonthlyExamDistributionDataVariable {
  examStartedAt: Date;
  examEndedAt: Date;
  examCenterCodes: string[];
  provinceIds: string[];
}

export default function useGetMonthlyExamDistributionData(
  variable: Readonly<UseGetMonthlyExamDistributionDataVariable>,
) {
  const { examStartedAt, examEndedAt, examCenterCodes, provinceIds } = variable;

  const { data: examEventData, loading: isGettingExamEvent } = useGetExamEventsByDateRangeQuery({
    variables: {
      getExamEventsByDateRangeInput: {
        examStartedAt,
        examEndedAt,
        examCenterCodes: examCenterCodes.length > 0 ? examCenterCodes : undefined,
        provinceIds: provinceIds.length > 0 ? provinceIds : undefined,
      },
    },
  });

  const { data: examEventCoursesData, loading: isGettingExamEventCourses } =
    useGetExamEventCoursesByExamEventIdsQuery({
      variables: {
        input: {
          examEventIds:
            examEventData?.ecGetExamEventsByDateRange.examEvents.map((examEvent) => examEvent.id) ??
            [],
        },
      },
      skip: !examEventData || isGettingExamEvent,
    });

  const { data: examCoursesData, loading: isGettingExamCourses } =
    useGetAllEnabledExamCoursesQuery();

  const examEvents = examEventData?.ecGetExamEventsByDateRange.examEvents ?? [];

  const examEventCourses =
    examEventCoursesData?.ecGetExamEventCoursesByExamEventIds.examEventCourses ?? [];

  const examCourses = examCoursesData?.ecGetAllEnabledExamCourses.examCourses ?? [];

  return {
    data: {
      examCourses,
      examEvents,
      examEventCourses,
    },
    loading: isGettingExamEvent || isGettingExamEventCourses || isGettingExamCourses,
  };
}
